import { createGenerator } from '../sprouts-engine';
import { pack } from '../content/math';

export const generateProblem = createGenerator(pack);
